/* Schneider Mode – Storefront-Erweiterungen (Cart-Staffel, Größenassistent, Farblabel, Footer) */
(function () {
  'use strict';

  var TIERS = [{ qty: 2, pct: 10 }, { qty: 3, pct: 15 }, { qty: 4, pct: 20 }];
  var MAX = TIERS[TIERS.length - 1];
  var ICON_GIFT = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 12v9H4v-9M2 7h20v5H2zM12 22V7M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>';
  var ICON_CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  function tierFor(q) { var t = null; for (var i = 0; i < TIERS.length; i++) if (q >= TIERS[i].qty) t = TIERS[i]; return t; }
  function nextTier(q) { for (var i = 0; i < TIERS.length; i++) if (q < TIERS[i].qty) return TIERS[i]; return null; }

  function buildProgress() {
    var el = document.createElement('div');
    el.className = 'sm-prog';
    el.setAttribute('data-sm-prog', '');
    el.innerHTML =
      '<div class="sm-prog__msg" data-sm-prog-msg></div>' +
      '<div class="sm-prog__track"><div class="sm-prog__fill" data-sm-prog-fill></div></div>' +
      '<div class="sm-prog__steps">' +
        TIERS.map(function (t) {
          return '<div class="sm-prog__step" data-sm-step="' + t.qty + '"><b>-' + t.pct + '%</b>' + t.qty + ' Artikel</div>';
        }).join('') +
      '</div>';
    return el;
  }

  function renderProgress(count) {
    each(document.querySelectorAll('#CartDrawer .drawer__scrollable, [data-sm-prog-host]'), function (host) {
      if (host.closest && host.closest('.drawer__cart-empty')) return;
      var prog = host.querySelector('[data-sm-prog]');
      if (!prog) { prog = buildProgress(); host.insertBefore(prog, host.firstChild); }
      var msg = prog.querySelector('[data-sm-prog-msg]');
      var fill = prog.querySelector('[data-sm-prog-fill]');
      var cur = tierFor(count);
      var nxt = nextTier(count);
      fill.style.width = (nxt ? Math.min(100, (count / MAX.qty) * 100) : 100) + '%';
      fill.classList.toggle('is-max', !nxt);

      if (count === 0) {
        msg.className = 'sm-prog__msg';
        msg.innerHTML = ICON_GIFT + '<span>Legen Sie <b>2 Artikel</b> in den Warenkorb und sparen Sie automatisch <b>10&nbsp;%</b> – ganz ohne Gutscheincode.</span>';
      } else if (nxt) {
        var missing = nxt.qty - count;
        msg.className = 'sm-prog__msg';
        msg.innerHTML = ICON_GIFT + '<span>Nur noch <b>' + missing + ' Artikel</b> bis <b>' + nxt.pct + '&nbsp;% Rabatt</b>' +
          (cur ? ' – aktuell sparen Sie bereits ' + cur.pct + '&nbsp;%.' : ' auf Ihren gesamten Warenkorb.') + '</span>';
      } else {
        msg.className = 'sm-prog__msg sm-prog__msg--done';
        msg.innerHTML = ICON_CHECK + '<span>Geschafft! Sie erhalten den maximalen Mengenrabatt von <b>' + MAX.pct + '&nbsp;%</b>. Der Abzug erfolgt automatisch im Checkout.</span>';
      }
      each(prog.querySelectorAll('[data-sm-step]'), function (s) {
        s.classList.toggle('on', count >= parseInt(s.getAttribute('data-sm-step'), 10));
      });
    });
  }

  function injectCartTrust() {
    var foot = document.querySelector('#CartDrawer .drawer__footer');
    if (!foot || foot.querySelector('.sm-cart-trust')) return;
    var box = document.createElement('div');
    box.className = 'sm-cart-trust';
    box.innerHTML = '<ul>' +
      '<li>' + ICON_CHECK + '60 Tage Rückgaberecht und kostenloser Rückversand</li>' +
      '<li>' + ICON_CHECK + 'Mit PayPal erst 30 Tage nach Versand bezahlen</li>' +
      '<li>' + ICON_CHECK + 'Versand aus unserem EU-Lager – keine Zollgebühren</li>' +
      '</ul>';
    var cta = foot.querySelector('.cart__checkout-wrapper');
    if (cta) foot.insertBefore(box, cta); else foot.appendChild(box);
  }

  var lastCount = -1;
  function syncCart(force) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var n = c.item_count || 0;
        if (n !== lastCount || force) { lastCount = n; renderProgress(n); }
        injectCartTrust();
      })
      .catch(function () {});
  }

  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function () {
      var args = arguments;
      var url = (args[0] && args[0].url) || args[0] || '';
      return _fetch.apply(this, args).then(function (res) {
        if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) setTimeout(function () { syncCart(true); }, 150);
        return res;
      });
    };
  }
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    if (typeof u === 'string' && /\/cart\/(add|change|update|clear)/.test(u)) {
      this.addEventListener('load', function () { setTimeout(function () { syncCart(true); }, 150); });
    }
    return _open.apply(this, arguments);
  };

  function initFooter() {
    each(document.querySelectorAll('.sm-footer__col h3'), function (h) {
      h.addEventListener('click', function () {
        if (window.matchMedia('(min-width:901px)').matches) return;
        h.parentNode.classList.toggle('is-open');
      });
    });
  }

  /* ---- Farbname im Label auf Deutsch halten ----
     Ein Teil des Katalogs führt die Farben auf Englisch. Das Theme schreibt beim
     Variantenwechsel den Rohwert ins Label – wir setzen die übersetzte Fassung nach. */
  function syncColorLabel() {
    var checked = document.querySelector('.sm-swatches input[data-variant-input]:checked');
    if (!checked) return;
    var de = checked.getAttribute('data-sm-de');
    if (!de) return;
    each(document.querySelectorAll('[data-variant-color-label]'), function (el) {
      if (el.textContent.trim() !== de) el.textContent = de;
    });
  }
  function initColorLabels() {
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('.sm-swatches')) setTimeout(syncColorLabel, 60);
    });
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.sm-swatches')) setTimeout(syncColorLabel, 140);
    });
    setTimeout(syncColorLabel, 400);
  }

  /* ---- Größenassistent ---- */
  var DAMEN = [17.5, 19.5, 22.5, 25.5, 29, 33, 37, 41, 46, 9999];
  var HERREN = [18.5, 20.5, 24, 27, 30.5, 34.5, 38.5, 43, 48, 9999];
  var ORDER = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL', '6XL'];
  var ALIAS = { 'XS': ['XS'], 'S': ['S'], 'M': ['M'], 'L': ['L'], 'XL': ['XL'],
    '2XL': ['2XL', 'XXL'], '3XL': ['3XL', 'XXXL'], '4XL': ['4XL', 'XXXXL'],
    '5XL': ['5XL', 'XXXXXL'], '6XL': ['6XL', 'XXXXXXL'] };

  function baseIdx(gender, h, w) {
    var bmi = w / Math.pow(h / 100, 2);
    var tbl = gender === 'herren' ? HERREN : DAMEN;
    for (var i = 0; i < tbl.length; i++) if (bmi < tbl[i]) return { idx: i, bmi: bmi };
    return { idx: tbl.length - 1, bmi: bmi };
  }

  function shoeSize(gender, cm) {
    var eu = Math.round((cm + 1.5) / 0.6667);
    return String(gender === 'herren' ? Math.max(38, Math.min(47, eu)) : Math.max(35, Math.min(44, eu)));
  }

  function sizeNodes() { return document.querySelectorAll('[data-sm-size-scope] .variant-input'); }

  function findOption(wanted) {
    var cands = (ALIAS[wanted] || [wanted]).map(function (s) { return String(s).toUpperCase(); });
    var hit = null;
    each(sizeNodes(), function (el) {
      if (hit) return;
      var v = (el.getAttribute('data-value') || '').trim().toUpperCase();
      if (cands.indexOf(v) !== -1) hit = el;
    });
    return hit;
  }

  function nearestAvailable(wantedIdx) {
    var exact = findOption(ORDER[wantedIdx]);
    if (exact) return { el: exact, idx: wantedIdx, exact: true };
    for (var d = 1; d < ORDER.length; d++) {
      var up = wantedIdx + d, dn = wantedIdx - d, e;
      if (up < ORDER.length) { e = findOption(ORDER[up]); if (e) return { el: e, idx: up, exact: false }; }
      if (dn >= 0) { e = findOption(ORDER[dn]); if (e) return { el: e, idx: dn, exact: false }; }
    }
    return null;
  }

  function initAssistant() {
    var modal = document.getElementById('smSizeModal');
    if (!modal) return;
    var form = modal.querySelector('[data-sm-form]');
    var res = modal.querySelector('[data-sm-res]');
    var err = modal.querySelector('[data-sm-err]');
    var gender = modal.getAttribute('data-sm-gender') || 'damen';
    var cat = modal.getAttribute('data-sm-cat') || 'oberteil';
    var isShoe = cat === 'schuhe';

    function open() { modal.classList.add('is-open'); document.body.classList.add('sm-noscroll');
      var f = modal.querySelector('input'); if (f) setTimeout(function () { f.focus(); }, 80); }
    function close() { modal.classList.remove('is-open'); document.body.classList.remove('sm-noscroll'); }

    document.addEventListener('click', function (e) {
      var o = e.target.closest ? e.target.closest('[data-sm-open]') : null;
      if (o) { e.preventDefault(); open(); return; }
      if (e.target.closest && e.target.closest('[data-sm-close]')) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    function fail(m) { err.textContent = m; err.classList.add('is-on'); }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      err.classList.remove('is-on');
      var fd = new FormData(form);

      if (isShoe) {
        var fl = parseFloat(String(fd.get('foot') || '').replace(',', '.'));
        if (!fl || fl < 18 || fl > 36) return fail('Bitte geben Sie eine Fußlänge zwischen 18 und 36 cm an.');
        showShoe(shoeSize(gender, fl), fl);
        return;
      }
      var h = parseFloat(String(fd.get('height') || '').replace(',', '.'));
      var w = parseFloat(String(fd.get('weight') || '').replace(',', '.'));
      var build = parseInt(fd.get('build') || '0', 10);
      var fit = parseInt(fd.get('fit') || '0', 10);
      if (!h || h < 130 || h > 215) return fail('Bitte geben Sie eine Körpergröße zwischen 130 und 215 cm an.');
      if (!w || w < 35 || w > 220) return fail('Bitte geben Sie ein Gewicht zwischen 35 und 220 kg an.');

      var b = baseIdx(gender, h, w);
      var idx = b.idx + build + fit;
      if (cat === 'jacke') idx += 1;
      idx = Math.max(0, Math.min(ORDER.length - 1, idx));
      showSize(idx, build, fit, cat);
    });

    function reasonText(cat, build, fit) {
      var bits = [];
      if (cat === 'jacke') bits.push('Jacken und Mäntel werden über weiterer Kleidung getragen – wir haben deshalb eine Größe zugegeben.');
      if (cat === 'strick') bits.push('Strick fällt weich und gibt beim Tragen leicht nach.');
      if (cat === 'hose') bits.push('Bei Hosen ist der Hüftumfang entscheidend – prüfen Sie ihn im Zweifel in der Größentabelle.');
      if (build > 0) bits.push('Für eine kräftigere Statur haben wir eine Größe zugegeben.');
      if (build < 0) bits.push('Für eine schlanke Statur haben wir eine Größe abgezogen.');
      if (fit > 0) bits.push('Sie möchten es locker – deshalb eine Nummer größer.');
      if (fit < 0) bits.push('Sie möchten es eng anliegend – deshalb eine Nummer kleiner.');
      if (!bits.length) bits.push('Auf Basis Ihrer Angaben sitzt diese Größe normal und angenehm.');
      return bits.join(' ');
    }

    function paint(label, why, targetEl) {
      res.querySelector('[data-sm-size]').textContent = label;
      res.querySelector('[data-sm-why]').textContent = why;
      var addBtn = res.querySelector('[data-sm-add]');
      addBtn.style.display = targetEl ? '' : 'none';
      addBtn.setAttribute('data-target-value', targetEl ? (targetEl.getAttribute('data-value') || '') : '');
      res.classList.add('is-on');
      try { res.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (e) {}
    }

    function showSize(idx, build, fit, cat) {
      var found = nearestAvailable(idx);
      var label = ORDER[idx], note = '';
      if (found && !found.exact) { label = ORDER[found.idx]; note = ' Genau Ihre Größe ist bei diesem Artikel gerade nicht verfügbar – ' + label + ' liegt am nächsten dran.'; }
      if (!found) note = ' Dieser Artikel ist aktuell in keiner passenden Größe verfügbar.';
      paint(label, reasonText(cat, build, fit) + note, found ? found.el : null);
    }

    function showShoe(eu, fl) {
      var found = null;
      each(sizeNodes(), function (el) {
        if (found) return;
        var v = (el.getAttribute('data-value') || '').trim();
        if (v === eu || v.indexOf(eu) === 0 || v.indexOf(eu + ' ') !== -1 || v.indexOf(eu + 'EU') !== -1 || v.indexOf(eu + ' EU') !== -1) found = el;
      });
      paint(eu, 'Bei einer Fußlänge von ' + fl.toFixed(1).replace('.', ',') + ' cm entspricht das der EU-Größe ' + eu + '.' +
        (found ? '' : ' Diese Größe ist bei diesem Modell gerade nicht verfügbar.'), found);
    }

    res.querySelector('[data-sm-add]').addEventListener('click', function () {
      var val = this.getAttribute('data-target-value');
      if (!val) return;
      var input = null;
      each(sizeNodes(), function (el) {
        if (input) return;
        if ((el.getAttribute('data-value') || '') === val) input = el.querySelector('input');
      });
      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      setTimeout(function () {
        close();
        var atc = document.querySelector('.add-to-cart:not([disabled])');
        if (atc) atc.click();
      }, 300);
    });
  }

  function boot() {
    syncCart(true);
    initFooter();
    initAssistant();
    initColorLabels();
    var drawer = document.getElementById('CartDrawer');
    if (drawer && window.MutationObserver) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        setTimeout(function () { pending = false; injectCartTrust(); syncCart(false); }, 200);
      }).observe(drawer, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
